module.exports = __webpack_public_path__ + "img/icon-msg-white.svg";